import {Carousel} from 'extensions/carousel';

export default class StackedSliders {

	constructor (pageContext, sliderElements) {
		this.pageContext = pageContext;
		this.sliderElements = sliderElements;

		this.init();
	}

	init () {

		for (const elem of this.sliderElements) {
			this.initSliders(elem);
		}

	}

	initSliders (elem) {
		this.imageSliderElem = elem.querySelector('.js-component-lp-stacked-slider__images');
		this.textSliderElem = elem.querySelector('.js-component-lp-stacked-slider__text');
		this.autoplay = parseFloat(elem.getAttribute('data-autoplay'));
		this.autoplaySpeed = parseFloat(elem.getAttribute('data-autoplay-speed'));

		if (!this.imageSliderElem || !this.textSliderElem) {
			return;
		}

		this.initTextSlider();
	}

	initTextSlider () {
		const carousel = new Carousel(this.textSliderElem, {
			arrows: true,
			autoplay: Boolean(this.autoplay),
			interval: this.autoplaySpeed > 0 ? this.autoplaySpeed : 5000,
			isNavigation: true,
			keyboard: 'focused',
			pagination: false,
			perPage: 1,
			rewind: true,
			type: 'loop'
		});

		if (carousel.slider) {
			carousel.slider.mount();
		}

		this.initImageSlider(carousel);
	}

	initImageSlider (textSlider) {
		const carousel = new Carousel(this.imageSliderElem, {
			arrows: false,
			keyboard: 'focused',
			pagination: true,
			perPage: 1,
			rewind: true,
			type: 'loop'
		});

		if (carousel.slider) {
			carousel.slider.sync(textSlider.slider).mount();
		}
	}

}
